import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute(
  '/_private/_route/_internal/people/$identityId/',
)({
  validateSearch: z.object({
    tab: z.string().optional().catch(undefined),
  }),
  beforeLoad: ({ context, params, search }) => {
    const { identityId } = params;
    if (!context.candidate) {
      throw redirect({
        params: { identityId },
        replace: true,
        to: '/people/$identityId/accounts',
      });
    }
    // `?tab=` is how candidate links were written before the page had tabs.
    switch (search.tab) {
      case 'commentary':
        throw redirect({
          params: { identityId },
          replace: true,
          to: '/people/$identityId/about',
        });
      case 'feedback':
        throw redirect({
          params: { identityId },
          replace: true,
          search: { page: 1, results: 10 },
          to: '/people/$identityId/feedback',
        });
      case 'recommendations':
        throw redirect({
          params: { identityId },
          replace: true,
          search: {
            page: 1,
            period: '3mo',
            results: 10,
            statsIntros: 'requests',
            statsType: 'submission',
            tab: 'all',
          },
          to: '/people/$identityId/recommendations',
        });
      case 'offlimits':
      case 'profile':
      default:
        throw redirect({
          params: { identityId },
          replace: true,
          to: '/people/$identityId/profile',
        });
    }
  },
});
